module.exports = __webpack_public_path__ + "img/cruise.c90552ba.svg";